/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$('.dropdown-toggle').hover(function() {
  if($(this).text().trim() == 'Damen') {
    $('#dropdown-damen .navigation-sub-sidemenu-link').removeClass('is-active');
  	$('#dropdown-damen .navigation-sub-category-menu').removeClass('is-active');
  	$('#dropdown-damen .m1, #dropdown-damen .s1').addClass('is-active');
  }
  if($(this).text().trim() == 'Herren') {
    $('#dropdown-herren .navigation-sub-sidemenu-link').removeClass('is-active');
  	$('#dropdown-herren .navigation-sub-category-menu').removeClass('is-active');
  	$('#dropdown-herren .m2, #dropdown-herren .s2').addClass('is-active');
  }
  if($(this).text().trim() == 'Personalisieren') {
    $('#dropdown-personalisieren .navigation-sub-sidemenu-link').removeClass('is-active');
  	$('#dropdown-personalisieren .navigation-sub-category-menu').removeClass('is-active');
  	$('#dropdown-personalisieren .m1, #dropdown-personalisieren .s1').addClass('is-active');
  }
});

$('#dropdown-damen .navigation-sub-sidemenu li a').hover(function() {
  $('#dropdown-damen .navigation-sub-sidemenu-link').removeClass('is-active');
  $('#dropdown-damen .navigation-sub-category-menu').removeClass('is-active');

  $(this).addClass('is-active');
  if($(this).hasClass('m1')) {
    $('#dropdown-damen .s1').addClass('is-active');
  }
  if($(this).hasClass('m2')) {
    $('#dropdown-damen .s2').addClass('is-active');
  }
  if($(this).hasClass('m3')) {
    $('#dropdown-damen .s3').addClass('is-active');
  }
});
$('#dropdown-herren .navigation-sub-sidemenu li a').hover(function() {
  $('#dropdown-herren .navigation-sub-sidemenu-link').removeClass('is-active');
  $('#dropdown-herren .navigation-sub-category-menu').removeClass('is-active');

  $(this).addClass('is-active');
  if($(this).hasClass('m1')) {
    $('#dropdown-herren .s1').addClass('is-active');
  }
  if($(this).hasClass('m2')) {
    $('#dropdown-herren .s2').addClass('is-active');
  }
  if($(this).hasClass('m3')) {
    $('#dropdown-herren .s3').addClass('is-active');
  }
});
$('#dropdown-personalisieren .navigation-sub-sidemenu li a').hover(function() {
  $('#dropdown-personalisieren .navigation-sub-sidemenu-link').removeClass('is-active');
  $('#dropdown-personalisieren .navigation-sub-category-menu').removeClass('is-active');

  $(this).addClass('is-active');
  if($(this).hasClass('m1')) {
    $('#dropdown-personalisieren .s1').addClass('is-active');
  }
  if($(this).hasClass('m2')) {
    $('#dropdown-personalisieren .s2').addClass('is-active');
  }
  if($(this).hasClass('m3')) {
    $('#dropdown-personalisieren .s3').addClass('is-active');
  }
});

//Anpassung der Lieferzeiten 
 document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
   	$( "button" ).each(function( i ) {
    	if(this.innerHTML == "Ausverkauft"){    		
          	document.getElementById('delivery-time').style.visibility = "hidden";
     	}
    	if(this.innerHTML.includes("In den Warenkorb")){    		
     		document.getElementById('delivery-time').style.visibility = "visible";
           
     	}
     })
   if(inv_qty[variant.id] > 0){
     element = document.getElementById('delivery-time').innerHTML = "Lieferzeit: 2 - 4 Tage";
   }
   else{
     element = document.getElementById('delivery-time').innerHTML = "Lieferzeit: 3 - 5 Wochen";
   }
  });

   
//   $('#generate-image').click(function(ev) {
//     var svg = document.querySelector('.configurator-slider.configurator-images-box svg');

//     $.ajax({
//       type: 'post',
//       url: 'https://converter.heydorn.com/convert',
//       dataType: 'json',
//       data: {
//         svg: getSvgHTML(svg)
//       },
//       success: function (data) {
//         processToCart(data.link);
//       }
//     });
//     ev.preventDefault();
//     return false;
//   });
   
  
/*
$('.size-chart-open-popup').magnificPopup({
  type:'inline',
  midClick: true
});
*/
function changeCookie(){
  let temp = $('#cookieconsent\\:desc');
  let cookieDescription = temp.length > 0 ? temp[0] : null;
  if (cookieDescription != null){
  	$('.cc-compliance.cc-highlight').before(cookieDescription);
    // $('#cookieconsent\\:settings').css("display","block")
    $('#cookieconsent\\:settings').show(); 
    return true;
  }else {
  	return false;
  }
}

var cookiec = (document.cookie.match(/^(?:.*;)?\s*cookieconsent_status\s*=\s*([^;]*)(?:.*)?$/)||[,null])[1];

if (cookiec == null){
    window.setTimeout(
      function(){
        if (!changeCookie()){
          console.log("cc not found!");
          window.setTimeout(
            function(){
              if (!changeCookie()){
              console.log("cc not found the second time!!!");
                window.setTimeout(
                function(){
                  if (!changeCookie()){
                  console.log("cc not found the third$$$!!!");
                    window.setTimeout(
                    function(){
                      if (!changeCookie()){
                      console.log("cc not found the 4th!!");
                      }
                    }
                  ,1500);
                  }
                }
              ,1500);
              }
            }
          ,2500);
        }

      }
      ,1000);
}